import { StyleSheet } from 'react-native';
import { colors, dimensions } from '../../../../styles';

export default StyleSheet.create({
  itemContainer: {
    height: 60,
    justifyContent: 'center',
    paddingHorizontal: dimensions.medium,
  },
  activeItemContainer: {
    backgroundColor: colors.grayLighter,
  },
});
